import { render } from "./S160285.vue?vue&type=template&id=d2938bc4"
const script = {}
script.render = render

export default script